import { MapTo } from '@adobe/aem-react-editable-components';
import CardDisclosuresMobileWallet, { CardDisclosuresMobileWalletEditConfig } from './CardDisclosuresMobileWallet';

export default MapTo('cob-corp-acquisition/components/creditonebank/card-disclosures-mobile-wallet')(CardDisclosuresMobileWallet, CardDisclosuresMobileWalletEditConfig);